/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS202: Simplify dynamic range loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
"use strict"

import Promise from "bluebird"
import _ from "lodash"
import angular from "angular"
import async from "async"
import moment from "moment-timezone"

import { getSnapshotUrl } from "../../../components/snapshot"
import {
  kStandardLabels,
  createDefaultFootfall,
  getStandardLabel,
} from "../../../components/counter-label"
import { getFootfallFeature } from "../../../components/util/footfall"
import { createFunctionalities, FeaturesController } from "./FeatureDependency"
import {
  getDeviceLicenseStatus,
  isRegistrableLicenseStatus,
  isVerifiedLicenseStatus,
} from "../../../lib/LicenseStatus"
import { parseFeaturesTwoLine, featuresTooltip } from "../../../components/parseFeatures"
import { matchText } from "common-library/utils/matchText.js"

angular
  .module("uCountitUiApp")

  .controller(
    "CameraCtrl",
    function (
      $rootScope,
      $scope,
      $filter,
      $window,
      $element,
      $anchorScroll,
      $timeout,
      $http,
      Auth,
      CameraAdminSrv,
      FaceDeviceSrv,
      CameraConfigSrv,
      ApiSrv,
      NotificationSrv,
      IotAdminSrv,
      Locale,
      ngDialog,
      NgTableParams,
      Upload,
      HeaderSrv,
      me,
      BrandSrv,
      ServiceTokenSrv,
      Heatmaptag,
      CameraDeleteSrv,
      usSpinnerService
    ) {
      $scope.isLocalgrey = $rootScope.globalConfig.isLocalgrey
      $scope.numberPattern = /^([1-9][0-9]{0,4})$|^100000$/
      $scope.floatPattern = /^[0-9]+(\.[0-9])?$/
      $scope.integerPattern = /^(0|-?[1-9][0-9]*)$/
      $scope.lineDirectionList = [
        { key: "right", name: Locale.string("Right") },
        { key: "left", name: Locale.string("Left") },
      ]
      $scope.isRegistrableLicenseStatus = isRegistrableLicenseStatus
      $scope.isVerifiedLicenseStatus = isVerifiedLicenseStatus
      $scope.strs = {
        config: Locale.string("Configuration"),
        virtualSensor: Locale.string("Virtual Sensor"),
        countingLine: Locale.string("Counting Lines"),
        heatmapTag: Locale.string("Zone Traffic"),
        trackingZone: Locale.string("Tracking Area"),
        countingArea: Locale.string("Counting Area"),
        directionMap: Locale.string("Flow Map"),
        cameraMemo: Locale.string("Camera Memo"),
        installLicense: Locale.string("Install License"),
        uninstallLicense: Locale.string("Uninstall License"),
        deleteData: Locale.string("Delete DB Data"),
        deleteSensor: Locale.string("Delete Sensor"),
        addStore: Locale.string("Add to Store"),
        servicePeriodTooltip: Locale.string("tooltip_service_period"),
        serviceStatusTooltip: Locale.string("tooltip_service_status"),
        featuresTooltip: featuresTooltip,
        timezoneTooltip: Locale.string("tooltip_timezone"),
        notRegistrableSensor: Locale.string("This sensor can not register. checkout status"),
        floatingStatusOk: Locale.string("msg_floating_status_ok"),
        floatingStatusUnverifiedLicense: Locale.string("msg_floating_status_unverified_license"),
        floatingStatusNoLicense: Locale.string("msg_floating_status_no_license"),
      }

      $scope.networkConnectionTypes = ["WiFi", "LTE", "PoE", "-"]

      if (me.isStore()) {
        return
      }

      $scope.itemName = Locale.string("Sensor")
      $scope.storePlaceholder = Locale.string("choose a store")
      $scope.counterSyncTooltip = Locale.string("counter_sync_tooltip")
      $scope.linkedSensorTooltip = Locale.string("msg_vff_linked_sensor")
      $scope.FootfallFeaturesTooltip = {
        mFF: Locale.string("tooltip_mff"),
        tFF: Locale.string("tooltip_tff"),
        fFF: Locale.string("tooltip_fff"),
      }
      $scope.inputDlgTitle = "Create"
      $scope.selectedLabels = []
      $scope.selectedStore = {}
      $scope.rgbPattern = /rgb\(\d+,\d+,\d+\)/
      let original = null

      $scope.isOpenUnlinkedCameraListDlg = true
      $scope.floatingCameras = []
      $scope.blacklist = []

      $scope.standardLabels = kStandardLabels
      $scope.hmtagSrv = null

      $scope.brandNav = BrandSrv.getBrand().navMenu
      $scope.brandFunctionalityFZHD = () =>
        $scope.brandNav.footfall ||
        $scope.brandNav.zonetraffic ||
        $scope.brandNav.heatmap ||
        $scope.brandNav.directionmap

      $scope.removedFootfalls = []
      $scope.footfalls = []
      $scope.periods = []
      $scope.onFaceChange = (face) => {
        if ($scope.form?.functions.use.face) {
          $scope.faceForm = {
            ...$scope.faceForm,
            ...face,
          }
        }
      }
      $scope.onVcaConfigChange = (vcaConfig) => {
        $scope.vcaConfig = vcaConfig
      }
      const isChangedVcaConfig = () => !_.isEqual($scope.vcaConfig, $scope.vcaConfigOrig)

      $scope.onGroupFaceChange = (gp) => {
        if ($scope.form?.functions.use.groupFace) {
          $scope.form.staffExclusion = {
            ...$scope.form?.staffExclusion,
            ...gp,
          }
        }
      }
      $scope.snapshotFormCfg = {}
      $scope.onSnapshotChange = (snapshot) => {
        if ($scope.form) {
          $scope.form.snapshot = {
            ...$scope.form.snapshot,
            ...snapshot,
          }
        }
      }

      $scope.openDlg = function (dlg, v) {
        const items = {
          input: "isOpenInputDlg",
          vs: "isOpenVSDlg",
          contentscleaner: "isOpenContentsCleanerDlg",
          heatmaptag: "isOpenHeatmapTagConfigDlg",
          trackingconfig: "isOpenTrackingConfigDlg",
          countingarea: "isOpenCountingAreaConfigDlg",
          direction: "isOpenDirectionConfigDlg",
          panorama: "isOpenPanoramaConfigDlg",
        }
        for (var key in items) {
          var value = items[key]
          $scope[value] = key === dlg ? v : false
        }

        if (v) {
          $timeout(() => $anchorScroll())
        }
      }

      $scope.openDlg("all", false)

      $scope.showIconMenu = function (item, menu) {
        const fns = item.functions.use
        const showFlag =
          menu === "trackingconfig"
            ? fns.zonetrace || fns.zonetraffic || fns.heatmaps
            : menu === "panoramazone"
            ? fns.flowmap
            : menu === "countingarea"
            ? fns.counter && fns.trackcounter
            : fns[menu] != null
            ? fns[menu]
            : false

        return !$scope.nowLoading && showFlag
      }

      const _getCameraUsn = (accessKey) => _.last(accessKey.split("-"))

      const defaultCameraSchema = function (funcs) {
        return {
          _storeId: "",
          name: "",
          ip: [],
          port: 80,
          macAddr: "",
          model: "",
          accessKey: "",
          id: "",
          passwd: "",
          thumbnail: {
            useSnapshot: true,
            path: "camera01.gif",
          },
          functions: {
            use: {
              counter: funcs.counter,
              trackcounter: funcs.counter && funcs.meta,
              metacounter: false,
              facecounter: false,
              heatmaps: false, // merge traffic heatmap and dwell heatmap(UCNT-3507)
              heatmap: false,
              trafficmap: (funcs != null ? funcs.meta : undefined) && true, // enable trafficmap as default
              dwellmap: false,
              directionmap: false,
              face: false,
              rtFace: false,
            },
          },
          active: true,
          snapshot: null,
          snapshotBIA: false,
          livePeriod: 0,
          editAccessKey: false,
          face: null,
          footfall: null,
          abnormal: {
            active: true,
          },
          dataMon: {
            active: true,
            features: {
              footfall: false,
              heatmap: false,
              zonetraffic: false,
              occupancy: false,
              genderage: false,
            },
          },
          availableGroupCount: false,
        }
      }

      // Feature-Use mapping for dataMon feature toggles
      var featureUseMapping = {
        footfall: ["counter", "metacounter", "trackcounter", "facecounter"],
        heatmap: ["heatmap", "dwellmap", "trafficmap"],
        zonetraffic: ["zonetraffic"],
        occupancy: ["occupancy"],
        genderage: ["face", "rtFace", "edgeFace", "groupFace"],
      }

      // dataMon.active 활성화 시 functions.use 기반으로 features 자동 세팅
      $scope.$watch("form.dataMon.active", function (newVal, oldVal) {
        if (newVal && !oldVal && $scope.form) {
          var use = $scope.form.functions && $scope.form.functions.use
          if (use) {
            $scope.form.dataMon.features = {
              footfall: !!(use.counter || use.metacounter || use.trackcounter || use.facecounter),
              heatmap: !!(use.heatmap || use.dwellmap || use.trafficmap),
              zonetraffic: !!use.zonetraffic,
              occupancy: !!use.occupancy,
              genderage: !!(use.face || use.rtFace || use.edgeFace || use.groupFace),
            }
          }
        }
      })

      // 해당 feature가 functions.use에서 활성화되어 있는지 확인
      $scope.isFeatureUsed = function (feature) {
        var use = $scope.form && $scope.form.functions && $scope.form.functions.use
        if (!use) return false
        return featureUseMapping[feature].some(function (key) {
          return !!use[key]
        })
      }

      $scope.$watch("showSelectedOrganization", (_value) => $scope.reload())

      const isChangedCounters = function () {
        const pick = ["active", "_labelId", "name", "bGroupCount", "groupCount", "faceWeight"]

        for (let idx = 0; idx < $scope.orgFootfalls.length; idx++) {
          var footfall = $scope.orgFootfalls[idx]
          if (!$scope.footfalls[idx]) {
            return true
          }

          var object = footfall.counters.map((c) => _.pick(c, pick))
          var other = $scope.footfalls[idx].counters.map((c) => _.pick(c, pick))
          if (!angular.equals(object, other)) {
            return true
          }
        }

        return false
      }

      const isChangedFootfallConfig = () =>
        !$scope.form.functions.use.trackcounter &&
        (isChangedCounters() || !angular.equals($scope.periods, $scope.orgPeriods))

      const setSubmitButtonTooltip = (message) => {
        $scope.submitButtonTooltip =
          message ?? "button will be active only when all fields are valid!"
      }

      const isPeriodValid = (beginDate, endDate) => {
        if (!beginDate || !endDate) return true
        const begin = new Date(beginDate)
        const end = new Date(endDate)
        if (Number.isNaN(begin.getTime()) || Number.isNaN(end.getTime())) {
          return true
        }
        return begin.getTime() <= end.getTime()
      }

      const isDataPeriodValid = (dataBeginDate, dataEndDate) => {
        return isPeriodValid(dataBeginDate, dataEndDate)
      }

      $scope.validateDataPeriod = () => {
        const valid = isDataPeriodValid($scope.form?.dataBeginDate, $scope.form?.dataEndDate)
        if ($scope.formDlg?.dataEndDate) {
          $scope.formDlg.dataEndDate.$setValidity("dataPeriod", valid)
        }
        return valid
      }

      $scope.$watchGroup(["form.dataBeginDate", "form.dataEndDate"], () => {
        if ($scope.form) {
          $scope.validateDataPeriod()
        }
      })

      const isServicePeriodValid = (serviceBeginDate, serviceEndDate) => {
        return isPeriodValid(serviceBeginDate, serviceEndDate)
      }

      $scope.validateServicePeriod = () => {
        const valid = isServicePeriodValid(
          $scope.form?.serviceBeginDate,
          $scope.form?.serviceEndDate
        )
        if ($scope.formDlg?.serviceEndDate) {
          $scope.formDlg.serviceEndDate.$setValidity("servicePeriod", valid)
        }
        return valid
      }

      $scope.$watchGroup(["form.serviceBeginDate", "form.serviceEndDate"], () => {
        if ($scope.form) {
          $scope.validateServicePeriod()
        }
      })

      $scope.canSubmit = function (formName) {
        if (!$scope[formName]) {
          return
        }
        if (
          !$scope.isOpenInputDlg ||
          !$scope.form ||
          ($scope.selectedStore != null ? $scope.selectedStore._id : undefined) == null
        ) {
          setSubmitButtonTooltip()
          return false
        }
        if (!hasFeatures()) {
          setSubmitButtonTooltip()
          return false
        }

        const dst = Object.assign({}, $scope.form)
        if (original != null) {
          delete original.editAccessKey
        }
        delete dst.editAccessKey
        if (original != null) {
          delete original.footfall
        }
        delete dst.footfall

        if (
          dst.snapshot.kind === "schedule" &&
          dst.snapshot.schedule.weekdays.length === 0 &&
          dst.snapshot.schedule.days.length === 0
        ) {
          setSubmitButtonTooltip("Snapshot: Check at least one weekday or input `Days`")
          return false
        }

        const servicePeriodOk = isServicePeriodValid(
          $scope.form?.serviceBeginDate,
          $scope.form?.serviceEndDate
        )
        if (!servicePeriodOk) {
          setSubmitButtonTooltip(Locale.string("msg_invalid_service_period"))
          return false
        }

        const dataPeriodOk = isDataPeriodValid($scope.form?.dataBeginDate, $scope.form?.dataEndDate)
        if (!dataPeriodOk) {
          setSubmitButtonTooltip(Locale.string("msg_invalid_data_period"))
          return false
        }

        const isValid =
          $scope[formName].$valid &&
          !$scope.nowLoading &&
          (!angular.equals(dst, original) ||
            isChangedFootfallConfig() ||
            isChangedVcaConfig() ||
            $scope.faceForm?.$dirty)
        setSubmitButtonTooltip(isValid ? "" : undefined)
        return isValid
      }

      $scope.setLoadingFlag = (flag) => ($scope.nowLoading = flag)

      $scope.submitForm = function () {
        $scope.setLoadingFlag(true)

        const dbColorPattern = /\d+,\d+,\d+/
        if ($scope.form.footfall.counters != null) {
          $scope.form.footfall.counters.forEach(function (counter) {
            counter.color = dbColorPattern.exec(counter.rgbcolor)
            if (counter.color) {
              counter.color = counter.color[0]
            }
          })
        }
        if ($scope.inputDlgTitle === "Create") {
          return createItem($scope.form)
        } else {
          return updateItem($scope.form)
        }
      }

      var createItem = async function (item) {
        try {
          const sobj = await CameraAdminSrv.save(item).$promise
          Auth.clientInfo(
            "admin.stores.lastSelectedStoreId",
            $scope.selectedStore != null ? $scope.selectedStore._id : undefined
          )
          item._id = sobj._id
          return updateItem(item, function (err) {
            console.warn(err)
          })
        } catch (error) {
          if (error.status === 409) {
            $scope.errorMessage = Locale.string("msg_error_accesskey_duplicated")
          } else {
            $scope.errorMessage = Locale.string("msg_error_create")
          }
          return $scope.setLoadingFlag(false)
        }
      }

      const _uploadImage = function (uploadUrl, imagePath, mode, callback) {
        if (imagePath && imagePath.type.indexOf("image/") > -1) {
          return Upload.upload({
            url: uploadUrl,
            data: {
              file: imagePath,
              mode,
            },
          }).then(
            (resp) => callback(null, resp.data),
            (resp) => callback({ message: `Fail to upload image(httpcode: ${resp.status})` })
          )
        } else {
          return callback()
        }
      }

      const isFootfallCfgChanged = function (original, item) {
        if (
          (original?.functions?.use?.counter || item?.functions?.use?.counter) &&
          item.floatingSensor
        ) {
          return true
        }
        if (original?.functions?.use?.counter != item?.functions?.use?.counter) {
          return true
        }

        return isChangedFootfallConfig()
      }

      const isEmptyHeatmapTags = function () {
        if (_.isNull($scope.form.heatmapTags)) {
          return true
        }
        return _.every($scope.form.heatmapTags, (n) =>
          _.every(n.heatmaptags, (t) => _.isEmpty(t.points))
        )
      }

      var updateFootfallSourceType = function (item) {
        const list = [
          ["metacounter", "VCA"],
          ["trackcounter", "CA"],
          ["facecounter", "FC"],
        ]

        for (let i = 0; i < list.length; i++) {
          const [feature, sourceType] = list[i]
          // 기존처럼 모든 footfalls를 변경하는게 맞는건지, 현재 periodic의 footfall만을 변경하는 맞는건지 애마하다.
          // 일단 모든 periodic의 footfall을 변경한다. 현재만 수정하려면 feature도 periodic을 지원해야한다.
          if (item.functions?.use?.[feature]) {
            $scope.footfalls.forEach((footfall) => {
              footfall.counters.forEach((counter, j) => {
                counter.sourceType = sourceType
                // facecounter는 첫번째 카운터만 사용한다.
                if (feature == "facecounter" && j) counter.active = false
              })
            })
          }
        }
      }

      function adjustDateToTimezone(date, timezone, isStartOfDay) {
        if (!date) return date
        return isStartOfDay
          ? moment.tz(date, timezone).startOf("day").toDate()
          : moment.tz(date, timezone).endOf("day").toDate()
      }
      var updateItem = function (item, callback) {
        if (callback == null) {
          callback = function () {}
        }
        return async.parallel(
          [
            function (next) {
              if (!item._id) {
                return next({ message: "no cameraId" })
              }
              if ($scope.form.snapshot?.fixed?.file) {
                const fixedSnapshotUploadUrl = `${$rootScope.globalConfig.apipath}/camera/${item._id}/fixedSnapshot`
                return _uploadImage(
                  fixedSnapshotUploadUrl,
                  $scope.form.snapshot.fixed.file,
                  null,
                  function (err, data) {
                    if (err) {
                      return next(err)
                    }
                    item.snapshot.fixed.url = data.fixed.url
                    return next(null, data)
                  }
                )
              } else {
                next()
              }
            },
            function (next) {
              if (!isFootfallCfgChanged(original, item)) {
                return next()
              }
              updateFootfallSourceType(item)

              const footfalls = $scope.footfalls.map((ff) => ({
                ...ff,
                _cameraId: item._id,
                from: moment.utc(ff.from),
                to: moment.utc(ff.to),
              }))

              footfalls.forEach((ff) => updateGroupCount(ff))

              return ApiSrv.FootfallConfigOfCamera()
                .set({ id: item._id }, footfalls)
                .$promise.then(() => next())
                .catch((err) => next(err))
            },
            function (next) {
              if ($scope.faceForm?.$dirty) {
                return FaceDeviceSrv.set(
                  { id: item._id },
                  { face: $scope.faceForm },
                  (res) => next(null, res),
                  (error) => next(error)
                )
              } else {
                next()
              }
            },
            function (next) {
              if (!item.floatingSensor) {
                return next()
              }

              const defaultTrackingSetting = [
                {
                  from: "2000-01-01T00:00:00Z",
                  to: "9000-01-01T00:00:00Z",
                  usn: _getCameraUsn(item.accessKey),
                  cameraInfo: {
                    calibrated: false,
                    altitude: 2.7,
                    // pan: 0
                    // tilt: 90
                    minFootRatio: 20,
                    maxFootRatio: 60,
                    objPosRatio: 50,
                  },
                  dwellConfig: {
                    staffRemoval: 600,
                    maxHovering: 0.3,
                    minDwellTime: 2,
                    maxDwellTime: 180,
                    minRoiTime: 3,
                    tsDwell: [10, 30, 60, 9999],
                    tsRoi: [30, 60, 120, 180, 300, 9999],
                  },
                },
              ]
              return CameraConfigSrv.set(
                { id: item._id, item: "trackAnalysis" },
                defaultTrackingSetting,
                (_res) => next(),
                (error) => next(error)
              )
            },
            function (next) {
              if (item.functions.use.zonetraffic === original.functions.use.zonetraffic) {
                return next()
              }
              if (!item.functions.use.zonetraffic) {
                return next()
              }
              if (!isEmptyHeatmapTags()) {
                return next()
              }

              if (!$scope.hmtagSrv) {
                $scope.hmtagSrv = new Heatmaptag(item._id)
              }

              const tags = [$scope.hmtagSrv.getHexagonTag()]
              tags[0].active = false // UCNT-3658, Default Off On Adding ZoneTraffic Feature
              const hmtag = [
                {
                  _cameraId: item._id,
                  heatmaptags: tags,
                },
              ]
              return $scope.hmtagSrv.setTags(hmtag).then(
                (_res) => next(),
                (error) => next(error)
              )
            },
            function (next) {
              if (isChangedVcaConfig()) {
                CameraConfigSrv.set(
                  { id: item._id, item: "vcaconfig" },
                  $scope.vcaConfig,
                  (_res) => next(),
                  (error) => next(error)
                )
              } else {
                next()
              }
            },
          ],
          function (err, _results) {
            if (err) {
              console.warn("updateItem End error", err)
            }
            const timezone = item.store != null ? item.store.timezone : undefined
            if (item.installationDate) {
              item.installationDate = adjustDateToTimezone(item.installationDate, timezone, true)
            }
            if (item.dataEndDate) {
              item.dataEndDate = adjustDateToTimezone(item.dataEndDate, timezone, false)
            }
            if (item.serviceBeginDate) {
              item.serviceBeginDate = adjustDateToTimezone(item.serviceBeginDate, timezone, true)
            }
            if (item.serviceEndDate) {
              item.serviceEndDate = adjustDateToTimezone(item.serviceEndDate, timezone, false)
            }
            if (item.accessKey && item.accessKey !== item.serialNum) {
              item.serialNum = item.accessKey
            }
            return CameraAdminSrv.update(
              { id: item._id },
              item,
              function (_sobj, _res) {
                $scope.openDlg("input", false)
                callback()
                $timeout(() => $scope.reload(false, () => HeaderSrv.emitter.reload()), 2000)
                if (me.gteAgency() && (!item.accessKey || item.editAccessKey)) {
                  $scope.loadedFloatingCameras = false
                  if ($scope.isOpenUnlinkedCameraList) {
                    //INFO: the iot client received reload command takes some time to be online.
                    $timeout(() => $scope.loadFloatingCameras(false), 10000)
                  }
                }
              },

              function (error) {
                callback(error)
                if (error.status === 409) {
                  $scope.errorMessage = Locale.string("msg_error_accesskey_duplicated")
                } else {
                  $scope.errorMessage = Locale.string("msg_error_update")
                }
                return $scope.setLoadingFlag(false)
              }
            )
          }
        )
      }

      const initializeSpecialCounter = (store) =>
        $scope.standardLabels.forEach(
          (label, idx) =>
            (label.color =
              __guard__(store != null ? store.specialLabels[idx] : undefined, (x) => x.color) !=
              null
                ? __guard__(store != null ? store.specialLabels[idx] : undefined, (x) => x.color)
                : kStandardLabels[idx].color)
        )

      /**
       * 1. 현재 조직만 보이기가 켜져 있으면 현재 Header의 Store
       * 2. 현재 조직만 보이기가 켜져 있고 마지막으로 선택한 Store가 Header의 Company와 동일하면 마지막 선택한 Store
       * 3. 현재 조직만 보이기가 꺼져 있으면 마지막으로 선택한 Store
       * 4. 현재 Header에 선택된 Company의 첫 Store
       */
      const getDefaultStore = function () {
        const hStoreId = HeaderSrv.getStoreId()
        const hCompanyId = HeaderSrv.getCompanyId()
        const showSelectedOrg = Auth.clientInfo("admin.showSelectedOrganization")

        let store

        if (showSelectedOrg) {
          store = $scope.stores.find((store) => store._id == hStoreId)
        }

        if (!store) {
          const lastSelectedStoreId = Auth.clientInfo("admin.stores.lastSelectedStoreId")
          if (showSelectedOrg) {
            store = $scope.stores.find(
              (store) => store._id == lastSelectedStoreId && store._companyId == hCompanyId
            )
          } else {
            store = $scope.stores.find((store) => store._id == lastSelectedStoreId)
          }
        }

        if (!store) {
          const company = $scope.companies.find((company) => hCompanyId == company._id)
          store = $scope.stores.find((store) => store._companyId == company._id)
        }

        return store ?? $scope.stores[0]
      }

      const loadForm = function (item) {
        let store
        setSubmitButtonTooltip()

        $scope.device = getDeviceByAccessKey(item.accessKey)
        $scope.functional = createFunctionalities($scope.device)
        if (item.uid) {
          // create sensor from floating sensor
          $scope.inputDlgTitle = "Create"

          $scope.isFloating = true
          $scope.form = defaultCameraSchema($scope.functional.device)
          _.merge($scope.form, _.pick(item, ["online", "accessKey", "ip", "fwversion", "dtype"]))
        } else {
          // load sensor
          $scope.inputDlgTitle = "Update"
          if (item.livePeriod == null) {
            item.livePeriod = defaultCameraSchema().livePeriod
          }
          item.availableGroupCount =
            item.functions.use.counter &&
            (item.functions.use.metacounter || item.functions.use.trackcounter)
          delete item.createdAt
          $scope.form = _.cloneDeep(item)
          $scope.isFloating = false
        }
        $scope.featureView = { ...$scope.form.functions.use }
        $scope.featureCtrl = new FeaturesController($scope.form.functions.use, item.dtype)

        $scope.errorMessage = ""
        $scope.warningMessage = ""
        original = null

        if (item._storeId) {
          store = _.find($scope.stores, { _id: item._storeId })
        } else {
          store = getDefaultStore()
        }

        let promiseChain
        if (item._id) {
          promiseChain = $http.get(`/api/camera/${item._id}/vcaconfig`).then((res) => {
            if (res.data) {
              $scope.vcaConfigOrig = _.pick(res.data, ["detectionPoint", "trackingEngine"])
              $scope.vcaConfig = $scope.vcaConfigOrig
            }
          })
        } else {
          promiseChain = Promise.resolve().then(() => ($scope.vcaConfig = {}))
        }

        return promiseChain
          .then(() => $scope.changeStore(store))
          .then(() => {
            original = angular.copy($scope.form)
            featureTransaction(() => {
              if ($scope.isFloating) {
                // UCNT-6415
                enableFeatureIfSupported("trackcounter")
                enableFeatureIfSupported("groupFace")
              }
              // Disable all features that device not support
              $scope.featureCtrl.disableUnsupportFeatures($scope.functional.license)
            })
          })
      }

      $scope.changeStore = function (store) {
        $scope.selectedStore = store
        $scope.form.store = store
        $scope.form._storeId = store._id
        $scope.selectedCompany = _.find($scope.companies, { _id: $scope.selectedStore._companyId })
        $scope.selectedAgency = _.find($scope.agencies, { _id: $scope.selectedCompany._agencyId })
        $scope.form._companyId = store._companyId
        initializeSpecialCounter(store)
        if ($scope.inputDlgTitle == "Create" && $scope.selectedStore) {
          $scope.form.snapshot = $scope.selectedStore.snapshot
        }
        $scope.issuableLicense =
          !(
            $scope.selectedAgency.permission?.noVcaLicenseInstallation ||
            $rootScope.globalConfig.isLocalgrey
          ) && $scope.device?.issuableLicense
        if ($scope.issuableLicense) {
          $scope.functional.license = $scope.functional.device
        }

        updateTrackEnabled($scope.form.functions.use)
        updateVcaConfigForm()

        return loadAllFeatureConfigs($scope.form).then(() =>
          Promise.all([
            NotificationSrv.Company.get({
              id: $scope.selectedCompany._id,
              _: Date.now(),
            }).$promise.then(function (nt) {
              if (nt) {
                return ($scope.form.notification = nt)
              } else {
                console.error("BUG: Not found notification for this company")
                return ($scope.form.notification = {
                  abnormal: {
                    active: false,
                    emails: [],
                  },
                  dataMon: {
                    active: false,
                  },
                })
              }
            }),

            getCompanyPolicy($scope.selectedStore._companyId),
            getBusinessHours($scope.selectedStore._id),
          ])
        )
      }

      $scope.changeAccessKey = _.debounce((accessKey) => {
        $scope.form.accessKey = accessKey
        // TODO: device 관련 사항을 모두 초기화 필요
        const device = getDeviceByAccessKey(accessKey)
        if (device) {
          $scope.form.dtype = device.description.properties.device.dtype
        } else {
          $scope.form.dtype = undefined
        }
        loadForm($scope.form)
      }, 200)

      function updateVcaConfigForm() {
        if ($scope.device) {
          $scope.vcaConfigFormProps = {
            availTrackingEngines: $scope.featureCtrl
              .availableTrackingEngines($scope.device.description.properties.vca.trackingEngines)
              .map((te) => te.id),
            deviceVca: $scope.device.description.properties.vca,
            deviceLicenses: $scope.device.licenses,
            noLicenseValidation: !$scope.issuableLicense,
          }
        } else {
          $scope.vcaConfigFormProps = {}
        }
      }
      $scope.isCompleteList = (list) => list && (list != null ? list.length : undefined) > 1

      $scope.openInputDlg = function (item) {
        $scope.setLoadingFlag(true)
        $scope.isSensorLinked = true
        $scope.faceForm = null
        $scope.vcaConfig = null
        $scope.functional = null
        $scope.featureCtrl = null

        return loadForm(item)
          .then(async () => {
            $scope.isSensorLinked = await checkSensorLinked(item)
          })
          .catch(function (err) {
            return console.warn("openInputDlg err", err)
          })
          .finally(() => {
            $scope.setLoadingFlag(false)
            $scope.openDlg("input", true)
            //$scope.formDlg.$setDirty()
          })
      }

      $scope.openSensorDlg = function (item) {
        if ((item != null ? item.model : undefined) === "panorama") {
          return $scope.openPanoramaDlg(item)
        } else {
          return $scope.openInputDlg(item)
        }
      }

      $scope.openVSDlg = function (item) {
        checkStoreLengh()
        $scope.openDlg("vs", true)
        return loadForm(item)
      }

      $scope.canSubmitVS = function (formName) {
        if (!$scope.isOpenVSDlg) {
          return false
        }
        if (($scope.selectedStore != null ? $scope.selectedStore._id : undefined) == null) {
          return false
        }
        $scope.form._storeId = $scope.selectedStore != null ? $scope.selectedStore._id : undefined
        return (
          $scope[formName].$valid &&
          ($scope.selectedStore != null ? $scope.selectedStore._id : undefined) &&
          !$scope.nowLoading &&
          !$scope.errorMessage
        )
      }

      $scope.submitVSForm = function () {
        const opt = {
          id: $scope.form._id,
          item: "virtual",
          storeId: $scope.form._storeId,
        }
        if ($scope.formDlgVS.cameraName.$dirty) {
          opt.cameraName = $scope.form.name
        }

        return CameraConfigSrv.set(
          opt,
          {},
          function (res) {
            $scope.errorMessage = `Success! new accessKey: ${res.accessKey}`
            return $scope.reload(false)
          },
          (err) => ($scope.errorMessage = err)
        )
      }

      var checkStoreLengh = function () {
        if (!($scope.stores != null ? $scope.stores.length : undefined)) {
          $window.alert(Locale.string("store list is empty"))
        }
      }

      $scope.openPanoramaDlg = async function (item) {
        if (item) $scope.panoramaSrc = `/v2/embed/admin/sensors/${item._id}/panorama/edit`
        else {
          let selectedStore = _.find($scope.stores, { _id: HeaderSrv.getStoreId() })
          if (!selectedStore) {
            selectedStore = _.find($scope.stores, { _companyId: HeaderSrv.getCompanyId() })
          }
          $scope.panoramaSrc =
            "/v2/embed/admin/sensors/panorama/new" +
            (selectedStore?._id ? `?defaultStoreId=${selectedStore._id}` : "")
        }
        $scope.openDlg("panorama", true)
      }

      $scope.closePanoramaDlg = function () {
        $scope.panoramaSrc = ""
        $scope.openDlg("panorama", false)
      }

      $scope.panoramaMessageHandler = (event) => {
        if (event.data?.type === "PANORAMA_RESIZE") {
          const iframe = $element.find("iframe.panorama-config")
          iframe[0].style.height = event.data.height + 2 + "px"
        }
        if (event.data?.type === "PANORAMA_SAVED") {
          $scope.reload(false, () => HeaderSrv.emitter.reload())
          $scope.closePanoramaDlg()
        }
      }

      $scope.openTrackingConfigDlg = function (item) {
        $scope.selectedItem = item
        $scope.trackingConfigSrc = `/v2/embed/admin/sensors/${item._id}/trackdevice`
        return $scope.openDlg("trackingconfig", true)
      }

      $scope.closeTrackingConfigDlg = function () {
        $scope.trackingConfigSrc = ""
        $scope.openDlg("trackingconfig", false)
      }

      $scope.trackingConfigMessageHandler = (event) => {
        if (event.data?.type === "TRACKDEVICE_RESIZE") {
          const iframe = $element.find("iframe.tracking-config")
          iframe[0].style.height = event.data.height + 2 + "px"
        }
        if (event.data?.type === "TRACKDEVICE_SAVED") {
          $scope.reload(false, () => HeaderSrv.emitter.reload())
          $scope.closeTrackingConfigDlg()
        }
      }

      const reloadSnapshot = function (item) {
        const canvasWidth = 800
        const canvasHeight = 450
        const snapshot = $element.find("#snapshotCanvas")
        let query = `?&_=${new Date().getTime()}`
        const servicetoken = ServiceTokenSrv.getToken()
        if (servicetoken) {
          query = `${query}&service_token=${servicetoken}`
        }
        const snapshotUrl = item.snapshotUrl + query
        snapshot.css({
          background: `url(${snapshotUrl})`,
          "background-size": canvasWidth + "px " + canvasHeight + "px",
          width: canvasWidth,
          height: canvasHeight,
        })
        return true
      }

      $scope.removeItem = function (item) {
        const deleteContent = {
          name: "deleteContent",
          message: Locale.string("msg_confirm_remove_content"),
          checked: true,
        }

        return ngDialog
          .openConfirm({
            template: "components/popup/popup-confirm.html",
            data: {
              header: item.cameraname,
              title: Locale.string("msg_confirm_remove_sensor"),
              option: [deleteContent],
            },
            closeByEscape: true,
            closeByDocument: true,
            showClose: false,
            className: "ngdialog-theme-default popup-confirm",
            controller: "ucPopupConfirmCtrl",
          })
          .then(function (_options) {
            showLoading("delete_camera")
            if (deleteContent.checked) {
              return CameraDeleteSrv.deleteData(item)
            } else {
              return Promise.resolve()
            }
          })
          .then(() => CameraDeleteSrv.deleteCamera(item._id))
          .then(function () {
            $scope.reload(false, () => HeaderSrv.emitter.reload())
            return hideLoading("delete_camera")
          })
      }

      $scope.filteredStores = (keyword) =>
        $filter("filter")($scope.stores, function (item) {
          const str = new RegExp(`.*${keyword}.*`, "i")
          return (
            __guard__(item != null ? item.companyName : undefined, (x) => x.match(str)) != null ||
            __guard__(item != null ? item.name : undefined, (x1) => x1.match(str)) != null
          )
        })

      $scope.reload = function (isCache, callback) {
        if (isCache == null) {
          isCache = true
        }
        if (callback == null) {
          callback = function () {}
        }
        const _reloadStatus = function (status) {
          const v = status === "start"
          $scope.reLoading = v
          return $scope.setLoadingFlag(v)
        }

        if ($scope.reLoading) {
          return
        }
        _reloadStatus("start")

        async.parallel(
          [
            (cback) => {
              ApiSrv.getAllAgency({ isCache: isCache }).then(function (res) {
                $scope.agencies = res
                return cback()
              })
            },

            (cback) =>
              ApiSrv.getAllCompany({ isCache: isCache }).then(function (res) {
                $scope.companies = _.map(res, (element) => ({
                  _id: element._id,
                  _agencyId: element._agencyId,
                  name: element.name,
                  active: element.active,
                  blockSnapshot: element.checkBlockedSnapshot(me),
                  face: element.face,
                  snapshot: element.policy?.snapshot,
                  zoneTraffic: element.zoneTraffic,
                  dwellmap: element.dwellmap,
                }))
                return cback()
              }),

            (cback) =>
              ApiSrv.getAllStore({ isCache: isCache }).then(function (res) {
                $scope.stores = _.map(res, (element) => ({
                  _id: element._id,
                  name: element.name,
                  labels: element.labels,
                  specialLabels: element.specialLabels,
                  active: element.active,
                  timezone: element.timezone,
                  _companyId: element._companyId,
                  companyName: __guard__(
                    _.find($scope.companies, { _id: element._companyId }),
                    (x) => x.name
                  ),
                  heatmapWeight: element.heatmapWeight,
                  stats: element.stats,
                  snapshot: element.policy?.snapshot,
                  serviceBeginDate: element.serviceBeginDate,
                  serviceEndDate: element.serviceEndDate,
                  dataBeginDate: element.dataBeginDate,
                  dataEndDate: element.dataEndDate,
                }))
                $scope.stores = $filter("orderBy")($scope.stores, [
                  "companyName",
                  "-active",
                  "name",
                ])
                return cback()
              }),

            (cback) =>
              ApiSrv.getAllCamera({ isCache: isCache }).then(function (res) {
                $scope.cameras = res
                  .filter((c) => !(c.isVirtual && c.model === "footfall"))
                  .map((c) => _.cloneDeep(c.data))
                return cback()
              }),

            (cback) =>
              loadIoTDevices(isCache, function (err, devices) {
                setDevices(devices)
                return cback(err)
              }),
          ],
          function (err) {
            if (err) {
              console.warn("$scope.reload err", err)
              $timeout(() => _reloadStatus("end"))
              callback(err)
              return
            }

            HeaderSrv.fetchCurrentStore()
              .then(function (orgInfo) {
                let cameraList
                $scope.cameras.forEach(function (camera) {
                  camera.store = _.find($scope.stores, { _id: camera._storeId })
                  camera.company = _.find($scope.companies, {
                    _id: camera.store != null ? camera.store._companyId : undefined,
                  })
                  camera.cameraname = `${
                    camera.company != null ? camera.company.name : undefined
                  } > ${camera.store != null ? camera.store.name : undefined} > ${camera.name}`
                  return setCameraInfo(camera)
                })

                if ($scope.showSelectedOrganization) {
                  cameraList = $filter("filter")($scope.cameras, function (camera) {
                    switch (orgInfo.orgType) {
                      case "company":
                        return (
                          orgInfo._id === (camera.company != null ? camera.company._id : undefined)
                        )
                      case "storegroup":
                        return (
                          orgInfo.storeList.indexOf(
                            camera.store != null ? camera.store._id : undefined
                          ) !== -1
                        )
                      case "store":
                        return orgInfo._id === (camera.store != null ? camera.store._id : undefined)
                      default:
                        return false
                    }
                  })
                } else {
                  cameraList = $scope.cameras
                }

                loadItems(cameraList)
                $timeout(() => _reloadStatus("end"))
                if (me.gteAgency() && $scope.isOpenUnlinkedCameraList) {
                  $scope.loadFloatingCameras()
                }
                return callback()
              })
              .catch(function (err) {
                console.warn("reload exception err", err)
                $timeout(() => _reloadStatus("end"))
                return callback(err)
              })
          }
        )
      }

      $scope.removeLicense = (item) =>
        $timeout(() => IotAdminSrv.removeLicense(item, { actor: me.email }))

      $scope.installLicense = (item) =>
        $timeout(() => IotAdminSrv.installLicense(item, { actor: me.email }))

      var setCameraLicense = function (camera, device) {
        camera.ucountlicense = getDeviceLicenseStatus(device)
      }

      var loadItems = function (items) {
        $scope.Items = items

        const _getData = function ($defer, params) {
          //const filter = $scope.searchKeywords
          const sorting = $scope.row
          const count = params.count()
          //const _page = params.page()
          $scope.pagecount = count

          $scope.filterItems = $filter("filter")($scope.Items, function (val) {
            return (
              (val?.company?.name && matchText(val.company.name, $scope.searchKeywords)) ||
              (val?.store?.name && matchText(val.store.name, $scope.searchKeywords)) ||
              (val?.name && matchText(val.name, $scope.searchKeywords)) ||
              (val?.accessKey && matchText(val.accessKey, $scope.searchKeywords))
            )
          })

          if (!$scope.filterItems) {
            return
          }
          params.total($scope.filterItems.length)
          const orderItems = $filter("orderBy")($scope.filterItems, sorting)

          const start = (params.page() - 1) * params.count()
          const end = start + params.count()
          $scope.currentPageItems = orderItems.slice(start, end)
          $defer.resolve($scope.currentPageItems)
        }

        return ($scope.tableParams = new NgTableParams(
          { count: $scope.pagecount != null ? $scope.pagecount : 25 },
          { counts: [10, 25, 50, 100], getData: _getData }
        ))
      }

      // filter
      $scope.searchKeywords = ""
      $scope.row = "cameraname"

      $scope.enterKeyword = function (keyword) {
        $scope.searchKeywords = keyword
        return loadItems($scope.Items)
      }

      $scope.order = function (rowName) {
        if ($scope.currentPageItems.length < 1) {
          return
        }
        $scope.row = rowName
        loadItems($scope.Items)
      }

      const loadFloatingItems = function (items) {
        $scope.floatingItems = items

        const _getData = function ($defer, _params) {
          $scope.currentFloatingItems = $filter("filter")($scope.floatingItems, function (val) {
            const str = new RegExp(`.*${$scope.searchFloatingKeywords}.*`, "i")

            return (
              val.frwversion?.match(str) ||
              val.uid?.match(str) ||
              val.ip?.some((addr) => addr.match(str))
            )
          })

          return $defer.resolve($scope.currentFloatingItems)
        }

        return ($scope.floatingTableParams = new NgTableParams(
          {},
          { counts: [], getData: _getData }
        ))
      }

      $scope.searchFloatingKeywords = ""

      $scope.enterFloatingKeyword = function (keyword) {
        $scope.searchFloatingKeywords = keyword
        return loadFloatingItems($scope.floatingItems)
      }

      const setCountingline2Form = function (cls, form) {
        form.footfall.counters.forEach($scope.clearCounter)

        return cls.forEach(function (cl, _idx) {
          if ((cl != null ? cl.source : undefined) == null) {
            return
          }
          const id = parseInt(cl.source.match(/\d+/)[0])

          const counter = form.footfall.counters[id]
          _.merge(counter, cl)
        })
      }

      $scope.loadIoTCounterInfo = (form) =>
        IotAdminSrv.Group("counter").get(
          { uid: form.accessKey, _: Date.now() },
          function (res) {
            setCountingline2Form(res.data, $scope.form)
            return reloadSnapshot(form)
          },
          function (error) {
            if (error.data != null) {
              $scope.errorMessage = error.data
            }
          }
        )

      const addIoTCounterInfo = function (item) {
        const idxes = []

        item.iotCounters.forEach(function (cl, _idx) {
          if ((cl != null ? cl.source : undefined) == null) {
            return
          }
          const id = parseInt(cl.source.match(/\d+/)[0])
          idxes.push(id)
          const fcounter = item.footfall.counters[id]
          if (fcounter) {
            fcounter.source = cl.source
            fcounter.cameraName = cl.name
          }
        })

        return item.footfall.counters.forEach(function (fcounter, idx) {
          if (idxes.indexOf(idx) >= 0) {
            return
          }
          fcounter.displayName = ""
        })
      }

      const isAciveGroupCount = (counter) =>
        !!(
          (counter.groupCount != null ? counter.groupCount.maxTime : undefined) &&
          (counter.groupCount != null ? counter.groupCount.linkTime : undefined)
        )

      var updateGroupCount = (ff) =>
        ff.counters.forEach(function (ct) {
          if (!ct.bGroupCount) {
            if (ct.groupCount) {
              ct.groupCount = { maxTime: 0, linkTime: 0 }
            }
          } else {
            if (
              !(
                (ct.groupCount != null ? ct.groupCount.maxTime : undefined) &&
                (ct.groupCount != null ? ct.groupCount.linkTime : undefined)
              )
            ) {
              ct.groupCount = { maxTime: 30, linkTime: 3 }
            }
          }
        })
      // if bGroupCount and counter.groupCount is active, keep values

      const loadFootfallCfg = function (form) {
        let footfallPromise, iotCountersPromise
        form.footfalltype = getFootfallFeature(form.functions)

        if (!form._id) {
          footfallPromise = Promise.resolve([
            {
              from: "2000-01-01",
              to: "9000-01-01",
              counters: createDefaultFootfall(form.footfalltype).counters,
            },
          ])
        } else {
          footfallPromise = ApiSrv.getFootfallsConfigOfCamera(
            form._id,
            form.store._id,
            { all: true },
            false
          )
        }

        if (form.isVirtual || !form.online || !form.accessKey) {
          iotCountersPromise = Promise.resolve([])
        } else {
          iotCountersPromise = IotAdminSrv.Group("counter")
            .get({ uid: form.accessKey, _: Date.now() })
            .$promise.then((res) => res.data)
            .catch(() => [])
        }

        return Promise.all([footfallPromise, iotCountersPromise])
          .spread(function (footfalls, iotCounters) {
            $scope.footfalls = footfalls.map(function (ff) {
              ff.from = moment.utc(ff.from).format("YYYY-MM-DD")
              ff.to = moment.utc(ff.to).format("YYYY-MM-DD")
              ff.counters.forEach((ct) => (ct.bGroupCount = isAciveGroupCount(ct)))
              return ff
            })

            $scope.periods = $scope.footfalls.map((ff) => _.pick(ff, ["id", "from", "to"]))

            if (!original) {
              $scope.orgPeriods = _.cloneDeep($scope.periods)
              $scope.orgFootfalls = _.cloneDeep($scope.footfalls)
            }

            return (form.iotCounters = iotCounters)
          })
          .catch(function (err) {
            if (form.functions.use.counter) {
              console.error("loadFootfallCfg error", err)
            }
          })
      }

      $scope.selectedPeriod = function (idx, isManual) {
        if (idx < 0) {
          return
        }

        if (isManual) {
          if ($scope.form.footfall != null) {
            $scope.form.footfall.counters.forEach(
              (counter, i) => (counter.label = $scope.selectedLabels[i])
            )
          }
        }

        $scope.selectedPeriodIdx = idx
        $scope.form.footfall = $scope.footfalls[idx]
        $scope.form.footfall.counters.forEach(
          (counter, i) => ($scope.selectedLabels[i] = counter.label)
        )

        addIoTCounterInfo($scope.form)
      }

      $scope.changedPeriod = function (removed) {
        let i
        for (i = removed.length - 1; i >= 0; i--) {
          var idx = $scope.footfalls.findIndex((footfall) => footfall._id === removed[i]._id)
          var removedFootfall = $scope.footfalls.splice(idx, 1)[0]
          if (removedFootfall) {
            $scope.removedFootfalls.push(removedFootfall)
          }
        }

        return (() => {
          let asc, end
          const result = []
          for (
            i = 0, end = $scope.periods.length, asc = 0 <= end;
            asc ? i < end : i > end;
            asc ? i++ : i--
          ) {
            if (!$scope.footfalls[i]) {
              var newFootfall = {
                from: $scope.periods[i].from,
                to: $scope.periods[i].to,
                counters: _.cloneDeep(
                  __guard__($scope.footfalls[i - 1], (x) => x.counters) ||
                    createDefaultFootfall($scope.form.footfalltype).counters
                ),
              }
              newFootfall.counters.forEach((ff) => delete ff._id)
              $scope.footfalls[i] = newFootfall
            }

            $scope.footfalls[i].from = $scope.periods[i].from
            result.push(($scope.footfalls[i].to = $scope.periods[i].to))
          }
          return result
        })()
      }

      const getDefaultFaceCfg = function (isEdge) {
        const defaultCfg = _.cloneDeep($scope.selectedCompany.face)
        if (isEdge) {
          defaultCfg.engine.kind = "edge"
          defaultCfg.engine.edge = {
            age: "edge",
            gender: "edge",
          }
          defaultCfg.quota = 10000
        }

        return defaultCfg
      }

      const loadFaceCfg = function (form) {
        if (!form._id) {
          return Promise.resolve()
        }

        return FaceDeviceSrv.get({ id: form._id })
          .$promise.then(function (res) {
            if ((res != null ? res.engine : undefined) != null) {
              res.retentionPeriod = $scope.selectedCompany.face.retentionPeriod
              return res
            }
          })
          .catch(function (err) {
            if (form.functions.use.face || form.functions.use.rtFace) {
              console.error("loadFaceCfg error", err)
              return {}
            }
          })
      }

      const loadZoneCfg = function (form) {
        if (!form._id) {
          return Promise.resolve()
        }

        $scope.hmtagSrv = new Heatmaptag(form._id)
        return $scope.hmtagSrv.getTags({ all: true }).catch(function (err) {
          if (form.functions.use.zonetraffic) {
            console.error("loadZoneCfg error", err)
          }
        })
      }

      var loadAllFeatureConfigs = function (form) {
        //INFO always reload footfall info by changed store label
        let facePromise, footfallPromise, zonePromise
        footfallPromise = loadFootfallCfg(form)

        if (!$scope.faceForm) {
          facePromise = loadFaceCfg(form).then((res) => {
            $scope.faceForm = res
          })
        } else {
          facePromise = Promise.resolve()
        }

        if (!form.heatmapTags) {
          zonePromise = loadZoneCfg(form).then((res) => (form.heatmapTags = res))
        } else {
          zonePromise = Promise.resolve()
        }

        return Promise.all([footfallPromise, facePromise, zonePromise])
      }

      // const isValidColor = (color) =>
      //   (color != null ? color.match(/\d+,\d+,\d+/) : undefined) != null

      $scope.clearCounter = function (counter) {
        counter.active = false
        counter.name = ""
        counter.displayName = ""
        counter.color = ""
        delete counter.labelpos
        delete counter.labelposString
        delete counter.linepoints
        return delete counter.linepointsString
      }

      $scope.setCounterValue = function (form, counter) {
        $scope.errorMessage = ""
        const countervalues = [{ id: counter.id, value: counter.count }]
        return IotAdminSrv.Group("counter/value").update(
          { uid: form.accessKey },
          countervalues,
          function (res) {
            if (res != null) {
              $scope.errorMessage = JSON.stringify(res)
            }
          },
          function (error) {
            if (error.data != null) {
              $scope.errorMessage = JSON.stringify(error.data)
            }
          }
        )
      }

      const getDateTime = function (date) {
        if (date) {
          return new Date(date)
        } else {
          return ""
        }
      }

      $scope.showDate = function (date, tz) {
        if (date) {
          return $filter("date")(date, "yyyy-MM-dd", tz)
        } else {
          return "-"
        }
      }

      $scope.showDatetime = function (date, tz) {
        if (date) {
          return $filter("date")(date, "yyyy-MM-dd HH:mm", tz)
        } else {
          return "-"
        }
      }

      const setServiceStatus = function (item) {
        const now = new Date()
        item.lastActivationDate = getDateTime(item.lastActivationDate)
        item.installationDate = getDateTime(item.installationDate)
        item.serviceBeginDate = getDateTime(item.serviceBeginDate)
        item.serviceEndDate = getDateTime(item.serviceEndDate)
        item.dataBeginDate = getDateTime(item.dataBeginDate)
        item.dataEndDate = getDateTime(item.dataEndDate)

        const A =
          isRegistrableLicenseStatus(item.ucountlicense) &&
          item.active &&
          item.store.active &&
          item.company.active
        const S = !(item.serviceEndDate && now > item.serviceEndDate)

        item.serviceStatusActive = A
        item.serviceStatusService = S
        const ss = (A ? "A" : "D") + "/" + (S ? "S" : "E")
        item.serviceStatusOrder = ["D/S", "A/E", "A/S", "D/E"].indexOf(ss)
        item.serviceStatusWarning = ss === "D/S" || ss === "A/E"
        return (item.serviceStatus = ss)
      }

      const setCameraFeatures = function (item) {
        const [fone, ftwo] = parseFeaturesTwoLine(item.functionalities)
        item.features_one = fone.join("·")
        item.features_two = ftwo.join("·")
        return
      }

      var setCameraInfo = function (item) {
        const device = _.find($scope.devices, { uid: item.accessKey })

        if (!device) {
          item.online = false
        }

        if (item.model === "panorama") {
          item.online = true
        }

        if (item.isVirtual) {
          item.ucountlicense = "verified"
        } else {
          setCameraLicense(item, device)
        }

        if (device && device.status && device.description) {
          item.online = device.online
          item.offset = device.description.properties.timezone.offset
          if (device.status.heartbeat != null ? device.status.heartbeat.at : undefined) {
            item.lastaccesstime = device.status.heartbeat.at
          } else {
            console.warn("No heartbeat at: ", device.uid)
          }
          if (device.status.uptime.bootat) {
            item.bootat = device.status.uptime.bootat
          }
          item.fwversion = device.description.properties.firmware.version
          item.dtype = device.description.properties.device.dtype
        }

        item.cameraname = `${item.company != null ? item.company.name : undefined} > ${
          item.store != null ? item.store.name : undefined
        } > ${item.name}`
        item.cameratimeoffset = item.offset
        if ((item.store != null ? item.store.timezone : undefined) != null) {
          item.storetimezone = item.store.timezone
          item.storetimeoffset = moment().tz(item.store.timezone).format("Z").replace(":", "")
        }
        if (item.cameratimeoffset != null) {
          item.differOffset = item.storetimeoffset !== item.cameratimeoffset
        }

        item.functionalities = item.functions != null ? item.functions.use : undefined
        if ((item.company != null ? item.company.name : undefined) === "TRASH") {
          item.abnormal.status = false
        }
        setCameraFeatures(item)
        setServiceStatus(item)

        item.snapshotUrl = getSnapshotUrl(item, ServiceTokenSrv, $rootScope.globalConfig)
      }

      var loadIoTDevices = (isCache, callback) =>
        IotAdminSrv.getAllDevice({ isCache: isCache }).then(
          (devices) => callback(null, devices),
          (err) => callback(err, [])
        )

      $scope.isOpenUnlinkedCameraList = false
      $scope.handleOpenUnlinkedCameraList = function () {
        $scope.isOpenUnlinkedCameraList = !$scope.isOpenUnlinkedCameraList
      }
      $scope.$watch("isOpenUnlinkedCameraList", (value) => {
        if (!$scope.loadedFloatingCameras && value) $scope.loadFloatingCameras()
      })

      $scope.loadFloatingCameras = function (isCache) {
        const _reloadStatus = function (status) {
          const v = status === "start"
          $scope.reLoadingFloating = v
          $scope.nowLoadingFloating = v
        }
        if ($scope.reLoadingFloating) {
          return
        }
        _reloadStatus("start")
        const setFloatingDevices = function (devices) {
          $scope.floatingCameras = []
          const floatinglist = []
          for (const device of devices) {
            const found = _.find($scope.cameras, { accessKey: device.uid })
            if (found) {
              continue
            }
            device.accessKey = device.uid
            device.ip = device.status?.network?.ipv4 ?? []
            device.licenseStatus = getDeviceLicenseStatus(device)
            device.agencies = device.description?.fota?.agencies ?? []
            delete device.rawconfig
            delete device._id

            //TODO: checking agency code UCNT-1297
            if (device.online && !_.find($scope.blacklist, { accessKey: device.accessKey })) {
              floatinglist.push(device)
            }
          }

          floatinglist.forEach(function (item) {
            item.fwversion =
              item.description != null ? item.description.properties.firmware.version : undefined
            item.dtype =
              item.description != null ? item.description.properties.device.dtype : undefined
            item.snapshotUrl = getSnapshotUrl(item, ServiceTokenSrv, $rootScope.globalConfig)
            item.displayStatuses = createFloatingStatuses(item)
            item.isRegistrable = isRegistrableDevice(item)
          })
          $scope.floatingCameras = floatinglist
          return loadFloatingItems(floatinglist)
        }

        return Promise.all([
          IotAdminSrv.getAllDevice({ isCache }).catch((_err) => []),
          IotAdminSrv.getAllFloatingDevice({ isCache }).catch((_err) => []),
          IotAdminSrv.getAllBlacklist({ isCache }),
        ])
          .spread(function (devices, floatingDevices, blacklist) {
            setDevices(devices)
            $scope.blacklist = blacklist
            $scope.loadedFloatingCameras = true
            return setFloatingDevices(floatingDevices)
          })
          .finally(() => $timeout(() => _reloadStatus("end")))
      }

      const deviceMap = {}
      function setDevices(devices) {
        $scope.devices = devices
        for (const device of devices) {
          deviceMap[device.uid] = device
        }
      }

      function getDeviceByAccessKey(accessKey) {
        return deviceMap[accessKey]
      }

      const createFloatingStatuses = (item) => {
        let statuses = []

        if (item.statusMessages) {
          for (const statusMessage of item.statusMessages) {
            const status = {
              isWarn: statusMessage.level == "warn",
              isErr: statusMessage.level == "err",
              messages: [],
            }
            statusMessage.level
            for (const message of statusMessage.messages) {
              if (message.kind == "translationKey") {
                status.messages.push(Locale.string(message.data))
              } else {
                status.messages.push(message.data)
              }
            }
            statuses.push(status)
          }
        }

        if (statuses.length == 0) {
          statuses.push({
            messages: ["OK"],
          })
        }

        return statuses
      }

      const isRegistrableDevice = (item) => {
        if (item.statusMessages) {
          return item.statusMessages.find((statusMessage) => statusMessage.level == "err")
            ? false
            : true
        }

        return true
      }

      $scope.registerCamera = function (camera) {
        let update
        if (camera.registered) {
          ;({ update } = IotAdminSrv.Group())
        } else {
          update = IotAdminSrv.Group().remove
        }
        return update({ uid: camera.accessKey }, camera)
      }

      $scope.openCameraMemo = function (camera) {
        window.scrollTo({ top: 0, behavior: "smooth" })
        return ngDialog.open({
          template: "components/cameranote/cameranote.html",
          data: camera,
          closeByEscape: true,
          closeByDocument: true,
          className: "ngdialog-theme-default cameranote",
          controller: "CameraNoteCtrl",
        })
      }

      $scope.changeStoreLabel = function (label, idx, counter) {
        $scope.selectedLabels[idx] = label
        return (counter._labelId = label._id)
      }

      var hasFeatures = function () {
        const fns = $scope.form.functions.use
        const features = [
          "counter",
          "zonetraffic",
          "directionmap",
          "flowmap",
          "face",
          "rtFace",
          "occupancy",
          "heatmaps",
        ]
        for (var f of Array.from(features)) {
          if (fns[f]) {
            return true
          }
        }
        return false
      }

      const createCountersIfMissing = function () {
        let isMissing = false

        $scope.footfalls.forEach(function (footfall) {
          if (footfall.counters.length === 0) {
            footfall.counters = createDefaultFootfall($scope.form.footfalltype).counters
            isMissing = true
          }
        })

        if (isMissing) {
          $scope.selectedPeriod($scope.selectedPeriodIdx, false)
        }
      }

      var updateTrackEnabled = (fns) =>
        ($scope.form.trackEnabled =
          fns.heatmaps ||
          fns.zonetraffic ||
          fns.directionmap ||
          fns.metacounter ||
          fns.facecounter ||
          fns.trackcounter)

      $scope.selectFeature = function (feature) {
        featureTransaction(() => {
          $scope.featureCtrl.toggleFeature(feature)
        })
      }

      const enableFeature = (feature) => {
        $scope.featureCtrl.enableFeature(feature)
      }

      const featureTransaction = (callback) => {
        const original = { ...$scope.form.functions.use }

        callback()

        if (!_.isEqual(original, $scope.form.functions.use)) {
          featureChangeHook(original)
          $scope.featureView = { ...$scope.form.functions.use }
        }
      }

      const featureChangeHook = (original) => {
        const changed = $scope.form.functions.use
        $scope.form.footfalltype = getFootfallFeature(changed)
        if (changed.counter) {
          createCountersIfMissing()
        }
        updateFootfallSourceType($scope.form)

        if (changed["face"] && !original["face"]) {
          if (_.isNil($scope.faceForm)) {
            $scope.faceForm = getDefaultFaceCfg(changed.edgeFace)
          }
        }
        if ($scope.faceForm != null) {
          $scope.faceForm.rtService = changed.rtFace
        }

        if (changed["groupFace"] && !original["groupFace"]) {
          // Set default value
          $scope.form.staffExclusion = null
          $scope.form.optimizeExposure = true
        } else {
          delete $scope.form.staffExclusion
        }

        if (!changed["groupFace"] && original["groupFace"]) {
          $scope.form.optimizeExposure = false
        }

        updateTrackEnabled(changed)
        updateVcaConfigForm()
      }

      $scope.featureVisible = (feature) => {
        const dep = $scope.featureCtrl.getDependency(feature)
        if (feature == "face" && dep.isMeta) {
          return false
        }
        return dep.canEnable($scope.functional.device)
      }

      $scope.featureCanEnable = (feature) => {
        const dep = $scope.featureCtrl.getDependency(feature)
        return dep.canEnable($scope.functional.license) && !dep.isMeta
      }

      const enableFeatureIfSupported = function (feature) {
        if ($scope.featureCanEnable(feature)) {
          enableFeature(feature)
        }
      }

      $scope.supportFaceFeature = () => {
        return $scope.featureVisible("face") || $scope.featureVisible("edgeFace")
      }

      $scope.supportFootfallSubFeatures = () => {
        return (
          $scope.featureCanEnable("metacounter") ||
          $scope.featureCanEnable("edgeFace") ||
          $scope.featureCanEnable("trackcounter")
        )
      }

      const LICENSE_STATUS = {
        NO_DIVICE: "no_device",
        SUPPORT: "support",
        NOT_SUPPORT: "not_support",
      }

      const getLicenseStatus = (feature) => {
        if (!$scope.featureCtrl.canEnable(feature, $scope.functional.device)) {
          return LICENSE_STATUS.NO_DIVICE
        } else {
          return $scope.featureCanEnable(feature)
            ? LICENSE_STATUS.SUPPORT
            : LICENSE_STATUS.NOT_SUPPORT
        }
      }

      const checkNotSupportLicencse = (status) => {
        return status === LICENSE_STATUS.NOT_SUPPORT
      }

      const FEATURES_GROUP1 = [
        { key: "metacounter", i18nKey: "mFF" },
        { key: "edgeFace", i18nKey: "fFF" },
        { key: "trackcounter", i18nKey: "tFF" },
        { key: "zonetraffic", i18nKey: "Zone Traffic" },
        { key: "heatmaps", i18nKey: "Heatmap" },
        { key: "directionmap", i18nKey: "Flow Map" },
      ]

      $scope.showLicenseInfoMsg = (type) => {
        let isShowMsg = false

        if (type == "group1") {
          isShowMsg = _.reduce(
            FEATURES_GROUP1,
            (res, feature) => {
              const status = getLicenseStatus(feature.key)
              return res || checkNotSupportLicencse(status)
            },
            false
          )
        } else if (type == "face") {
          const edgeFaceLicenseStatus = getLicenseStatus("edgeFace")
          const faceLicenseStatus = getLicenseStatus("face")
          const rtFaceLicenseStatus = getLicenseStatus("rtFace")
          const groupFaceLicenseStatus = getLicenseStatus("groupFace")

          isShowMsg =
            (checkNotSupportLicencse(edgeFaceLicenseStatus) &&
              checkNotSupportLicencse(faceLicenseStatus)) ||
            checkNotSupportLicencse(rtFaceLicenseStatus) ||
            checkNotSupportLicencse(groupFaceLicenseStatus)
        } else {
          isShowMsg = checkNotSupportLicencse(getLicenseStatus(type))
        }

        return isShowMsg
      }

      $scope.getNotSupportLicenseList = (type) => {
        let list = ""
        if (type == "group1") {
          let addComma = false
          _.forEach(FEATURES_GROUP1, (feature) => {
            const status = getLicenseStatus(feature.key)
            if (checkNotSupportLicencse(status)) {
              if (addComma) {
                list += ", "
                addComma = false
              }
              list += Locale.string(feature.i18nKey)
              addComma = true
            }
          })
        } else {
          list = Locale.string(type)
        }

        return list
      }

      $scope.getCompanyNameOfStore = (store) =>
        store.companyName != null ? store.companyName : "-"

      $scope.openContentsCleanerDlg = function (item) {
        $scope.selectedItem = item
        return $scope.openDlg("contentscleaner", true)
      }

      $scope.openHeatmapTagConfigDlg = function (item) {
        $scope.selectedItem = item
        return $scope.openDlg("heatmaptag", true)
      }

      $scope.$on("heatmaptag_config_complete", function () {
        $scope.openDlg("heatmaptag", false)
        return $scope.reload(false)
      })

      $scope.openCountingAreaConfigDlg = function (item) {
        $scope.selectedItem = item
        return $scope.openDlg("countingarea", true)
      }

      $scope.$on("countingarea_config_complete", function () {
        $scope.openDlg("countingarea", false)
        return $scope.reload(false)
      })

      $scope.openDirectionConfigDlg = function (item) {
        $scope.selectedItem = item
        return $scope.openDlg("direction", true)
      }

      $scope.$on("direction_config_complete", function () {
        $scope.openDlg("direction", false)
        return $scope.reload()
      })

      $scope.isSpecialCounter = (counter) => getStandardLabel(counter)

      var getCompanyPolicy = function (companyId, isCreate) {
        if (!companyId) {
          return Promise.resolve()
        }

        return ApiSrv.getCompany({ id: companyId, isCache: true }).then(function (res) {
          if (!res) {
            return Promise.resolve()
          }

          $scope.snapshotFormCfg.usePrivacyLaw =
            (res.policy.privacyLaw != null ? res.policy.privacyLaw.superAdmin : undefined) ||
            (res.policy.privacyLaw != null ? res.policy.privacyLaw.companyAdmin : undefined)

          return ApiSrv.getAgency({ id: res._agencyId, isCache: true }).then(function (agency) {
            if (!agency) {
              return
            }

            if (agency.policy != null ? agency.policy.noPersonalData : undefined) {
              $scope.snapshotFormCfg.noPersonalData = true
              $scope.form.functions.misc = {
                blackboxImage: {
                  active: false,
                },
              }
            }
            $scope.selectedAgency = agency
          })
        })
      }

      var getBusinessHours = function (storeId) {
        if (!storeId) {
          return Promise.resolve()
        }

        return ApiSrv.getStore({ id: storeId }).then(function (res) {
          if (!res) {
            return Promise.resolve()
          }
          $scope.businessHours = res.schedule?.businessHours
        })
      }

      $scope.getCounterName = function (counter) {
        if (!counter || !counter.name) {
          return ""
        }
        return `[${counter.source}] ${counter.name}`
      }

      $scope.syncCounterConfig = (form) =>
        form.footfall.counters.forEach(function (counter, i) {
          const iotCounter = form.iotCounters[i]
          if (iotCounter) {
            _.merge(
              counter,
              _.pick(iotCounter, [
                "active",
                "source",
                "name",
                "linedirection",
                "lineobjectwidth",
                "linepoints",
              ])
            )
            counter.displayName = `[${counter.source}] ${counter.name}`
          }
        })

      $scope.isSyncAllCounters = function (counters) {
        if (!counters) {
          return false
        }

        const res = _.filter(counters, { sync: false })
        return res.length === 0
      }

      $scope.isSyncCounter = function (form, index) {
        const counter = form.footfall.counters[index]
        if (!form.online) {
          counter.sync = true
        } else {
          const iotCounter = form.iotCounters[index]
          if (counter && iotCounter) {
            counter.sync =
              counter.active &&
              counter.source === iotCounter.source &&
              counter.name === iotCounter.name
          } else {
            counter.sync = counter.active ? false : true
          }
        }

        return counter.sync
      }

      $scope.isValidNumber = (error) => _.isEqual(error, {})

      $scope.selectOperation = function (item, ops, body) {
        if (body == null) {
          body = {}
        }
        if (!$window.confirm("Are you sure?")) {
          return
        }
        $scope.errorMessage = null
        IotAdminSrv.Group("operation").update(
          { uid: item.accessKey, command: ops },
          body,
          function (res) {
            if (res.error != null) {
              return ($scope.errorMessage = res.error)
            }
            // return ($scope.errorMessage = "success command: " + cmd)
            return ($scope.errorMessage = "success command: " + ops)
          },
          function (error) {
            if (error.data != null) {
              $scope.errorMessage = error.data
            }
          }
        )
      }

      $scope.getDisplayLabelName = function (label) {
        const sLabel = _.find(kStandardLabels, ["name", label])
        if (sLabel) {
          return Locale.string(sLabel.i18nKey)
        } else {
          return label
        }
      }

      var showLoading = function (_key) {
        angular.element(".splash").show()
        usSpinnerService.spin("spinner")
        return angular.element(".spinner").css("position", "fixed")
      }

      var hideLoading = function (_key) {
        angular.element(".splash").hide()
        return usSpinnerService.stop("spinner")
      }

      $scope.forcedSnapshot = async (item) => {
        try {
          const res = await $http.post(`/api/1.0/camera/${item._id}/forced-snapshot`)
          if (res.status != 200) {
            alert(res.data.message)
          }
        } catch (err) {
          alert(err.data?.message || err.message)
        }
      }

      $scope.searchSensorForm = {
        accessKey: "",
      }

      $scope.$watch(
        "searchSensorForm",
        () => {
          $scope.searchSensorResult = null
        },
        true
      )

      $scope.searchSensor = async () => {
        const { accessKey } = $scope.searchSensorForm
        if (!accessKey) return

        try {
          const params = accessKey.includes("-") ? { accessKey } : { endusn: accessKey }
          const res = await $http.get(`/api/1.0/camera/search`, { params })

          if (res.status === 200) {
            $scope.searchSensorResult = res.data
          }
        } catch {
          $scope.searchSensorResult = null
        }
      }

      // UCNT-5046 수정중인 센서가 VFF에 연결된 센서인지 확인
      const checkSensorLinked = async (sensorInfo) => {
        if (!sensorInfo) return false
        const sensors = await ApiSrv.getCameraOfStore({ id: sensorInfo._storeId, isCache: true })
        const vffSensor = sensors.find((sensor) => sensor.model === "footfall")
        if (vffSensor) {
          const footfalls = await ApiSrv.getFootfallsConfigOfCamera(
            vffSensor._id,
            vffSensor._storeId,
            { all: true },
            false
          )
          for (const footfall of footfalls || []) {
            for (const counter of footfall.counters || []) {
              if (counter?.rule?.orgId === sensorInfo._id) return true
            }
          }
        }
        return false
      }

      //#############################################################################
      // Main Code
      $scope.reload()
    }
  )

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null ? transform(value) : undefined
}
